module.exports = __webpack_public_path__ + "img/g_mro_12.1eaa70a6.png";